import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateJurisdictionSetupCompletedMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  setupCompleted: Types.Scalars['Boolean']['input'];
}>;


export type UpdateJurisdictionSetupCompletedMutation = { __typename?: 'mutation_root', update_jurisdictions_by_pk?: { __typename?: 'jurisdictions', id: any, setup_completed: boolean } | null };


export const UpdateJurisdictionSetupCompletedDocument = gql`
    mutation UpdateJurisdictionSetupCompleted($id: uuid!, $setupCompleted: Boolean!) {
  update_jurisdictions_by_pk(
    pk_columns: {id: $id}
    _set: {setup_completed: $setupCompleted}
  ) {
    id
    setup_completed
  }
}
    `;
export type UpdateJurisdictionSetupCompletedMutationFn = Apollo.MutationFunction<UpdateJurisdictionSetupCompletedMutation, UpdateJurisdictionSetupCompletedMutationVariables>;

/**
 * __useUpdateJurisdictionSetupCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateJurisdictionSetupCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJurisdictionSetupCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJurisdictionSetupCompletedMutation, { data, loading, error }] = useUpdateJurisdictionSetupCompletedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      setupCompleted: // value for 'setupCompleted'
 *   },
 * });
 */
export function useUpdateJurisdictionSetupCompletedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJurisdictionSetupCompletedMutation, UpdateJurisdictionSetupCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJurisdictionSetupCompletedMutation, UpdateJurisdictionSetupCompletedMutationVariables>(UpdateJurisdictionSetupCompletedDocument, options);
      }
export type UpdateJurisdictionSetupCompletedMutationHookResult = ReturnType<typeof useUpdateJurisdictionSetupCompletedMutation>;
export type UpdateJurisdictionSetupCompletedMutationResult = Apollo.MutationResult<UpdateJurisdictionSetupCompletedMutation>;
export type UpdateJurisdictionSetupCompletedMutationOptions = Apollo.BaseMutationOptions<UpdateJurisdictionSetupCompletedMutation, UpdateJurisdictionSetupCompletedMutationVariables>;